import { StyleSheet } from "react-native";

const styles = StyleSheet.create({

  inputStyle: {
    textAlign: "center",
    width: "70%",
    height: 60,
    fontSize: 22,
    color: "#222",
    backgroundColor: "#f1f1f1",
    borderTopWidth: 1,
    borderBottomWidth: 1,
    borderColor: "#ccc"
  },
  containerStyle: {
    position: "relative",
    flexDirection: "row",
    width: 300
  },
  buttonStyle: {
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: "#fff",
    borderWidth: 1,
    borderColor: "#ccc",
    borderRadius: 6,
    flex: 1,
  },
  buttonText: {
    fontSize: 22,
    color: "#222",
  },
  buttonLeft: {
    borderTopRightRadius: 0,
    borderBottomRightRadius: 0
  },
  buttonRight: {
    borderTopLeftRadius: 0,
    borderBottomLeftRadius: 0
  },
})
export default styles;
